import { createSelector } from 'reselect';
import { createAction } from '@mews/framework';
import { ApplicationState } from '@mews-commander/types';
import { AvailabilityBlock } from '@mews-commander/data-access';
import moduleSelector from '../selector';
import prefix from '../prefix';
import { createEntityFormattedMetaSelector } from '../selectors/form';
import { createEntitiesReducer, createBaseEntitySelectors } from './utils';

export const NAME = 'availabilityBlocks';

const AVAILABILITY_BLOCKS_LOADED = prefix('AVAILABILITY_BLOCKS_LOADED');
const AVAILABILITY_BLOCKS_DELETED = prefix('AVAILABILITY_BLOCKS_DELETED');
const AVAILABILITY_BLOCKS_ADDED = prefix('AVAILABILITY_BLOCKS_ADDED');

export const setAvailabilityBlocks = (availabilityBlocks: AvailabilityBlock[]) =>
    createAction(AVAILABILITY_BLOCKS_LOADED, { entities: availabilityBlocks });
export const deleteAvailabilityBlocksFromState = (ids: string[]) => createAction(AVAILABILITY_BLOCKS_DELETED, ids);
export const addAvailabilityBlocksFromState = (availabilityBlocks: AvailabilityBlock[]) =>
    createAction(AVAILABILITY_BLOCKS_ADDED, availabilityBlocks);

export const availabilityBlocksReducer = createEntitiesReducer({
    FETCH_SUCCESS: AVAILABILITY_BLOCKS_LOADED,
    DELETE_SUCCESS: AVAILABILITY_BLOCKS_DELETED,
    ADD_SUCCESS: AVAILABILITY_BLOCKS_ADDED,
});

export const [getAvailabilityBlocks, getAvailabilityBlocksByIds, getAvailabilityBlocksByOwnerId, getAvailabilityBlock] =
    createBaseEntitySelectors<ApplicationState, AvailabilityBlock, typeof NAME>(moduleSelector, NAME);

/**
 * @deprecated use useAvailabilityBlock or useAvailabilityBlockInfo
 */
export const getAvailabilityBlockUtcDateRange = createSelector(getAvailabilityBlock, (availabilityBlock) => ({
    startUtc: availabilityBlock?.startUtc,
    endUtc: availabilityBlock?.endUtc,
}));

export const getAvailabilityBlockFormattedMeta = createEntityFormattedMetaSelector(getAvailabilityBlock);
